import React from 'react';
import PropTypes from 'prop-types';
import css from './HeaderTitle.css';
import { getWord } from "utils/tenant";

export default class HeaderTitle extends React.Component {

  get title() {
    if ( this.props.title !== "" ) return this.props.title;
    if ( !this.props.isMobile ) return getWord('Starfish');
    return document.title !== null && document.title !== "" && typeof document.title !== "undefined"
      ? document.title.split(" |")[0]
      : getWord('Starfish');
  }

  render() {
    return <div id="main-navigation-title" className={css['title']}>{this.title}</div>;
  }
}

HeaderTitle.propTypes = {
  title: PropTypes.string.isRequired,
  isMobile: PropTypes.bool
};
